<div class="padding">
  <h1 class="left-box">{{ 'accounting.disbursementPricing' | transloco }}</h1>
  @if (repo.resource$ | async; as data) {
    <div>
      <app-disbursement-pricing-filter></app-disbursement-pricing-filter>
      <div class="spacer-small"></div>
      <div class="spacer-small"></div>
      <!-- Main orders table -->
      @if (data) {
        <div class="table-container">
          <!-- Conditional paginator at the top (show only when number of orders displayed is >= 50) -->
          @if (data.length >= 50) {
            <div>
              <mat-paginator [pageSize]="this.repo.pageSize$ | async"
                [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
                [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
              (page)="page($event)"></mat-paginator>
              <div class="spacer-small"></div>
            </div>
          }
          <!-- End of conditional paginator at the top -->
          <!-- Pricing table -->
          <table mat-table matSort [dataSource]="this.repo.resource$" multiTemplateDataRows
            class="mat-elevation-z0" (matSortChange)="sort($event)"
            [class.table-loading]="this.repo.loading$ | async">
            <!-- Product Code -->
            <ng-container matColumnDef="productCode">
              <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.productCode' | transloco }} </th>
              <td mat-cell *matCellDef="let price"> {{price.productCode}} </td>
            </ng-container>
            <!-- Description -->
            <ng-container matColumnDef="description">
              <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.description' | transloco }} </th>
              <td mat-cell *matCellDef="let price"> {{price.description}} </td>
            </ng-container>
            <!-- Total -->
            <ng-container matColumnDef="total">
              <th mat-header-cell *matHeaderCellDef> {{ 'common.labels.total2' | transloco }} </th>
              <td mat-cell *matCellDef="let price"> {{(price.amount + (price.amount * price.taxRate.gstRate) + (price.amount * price.taxRate.pstRate) + (price.amount * price.taxRate.hstRate)) |
              currency}} </td>
            </ng-container>
            <ng-container matColumnDef="indicator">
              <th mat-header-cell *matHeaderCellDef id="indicator"></th>
              <td mat-cell *matCellDef="let price">
                <lib-disclosure-indicator [isExpanded]="price == expandedPrice"></lib-disclosure-indicator>
              </td>
            </ng-container>
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell *matCellDef="let price" [attr.colspan]="displayedColumns.length">
                <div class="expanded-entity-detail"
                  [@detailExpand]="price == expandedPrice ? 'expanded' : 'collapsed'">
                  <div class="expanded-entity-information">
                    <div class="flex-container">
                      <div class="flex-item">
                        <mat-list>
                          <mat-list-item>
                            <span matListItemTitle>{{ 'common.labels.amount' | transloco }}</span>
                            <span matListItemLine>{{ price.amount | currency }}</span>
                          </mat-list-item>
                        </mat-list>
                      </div>
                      <div class="flex-item">
                        <mat-list>
                          <mat-list-item>
                            <span matListItemTitle>{{ 'common.labels.taxRate' | transloco }}</span>
                            <span matListItemLine>{{ price.taxRate.code }}</span>
                          </mat-list-item>
                        </mat-list>
                      </div>
                      <div class="flex-item">
                        <mat-list>
                          <mat-list-item>
                            <span matListItemTitle>{{ 'common.labels.gstRate' | transloco }}</span>
                            <span matListItemLine>{{ price.taxRate.gstRate | percent }}</span>
                          </mat-list-item>
                        </mat-list>
                      </div>
                      <div class="flex-item">
                        <mat-list>
                          <mat-list-item>
                            <span matListItemTitle>{{ 'common.labels.pstRate' | transloco }}</span>
                            <span matListItemLine>{{ price.taxRate.pstRate | percent }}</span>
                          </mat-list-item>
                        </mat-list>
                      </div>
                      <div class="flex-item">
                        <mat-list>
                          <mat-list-item>
                            <span matListItemTitle>{{ 'common.labels.hstRate' | transloco }}</span>
                            <span matListItemLine>{{ price.taxRate.hstRate | percent }}</span>
                          </mat-list-item>
                        </mat-list>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let price; columns: displayedColumns;" class="expandable-table-row"
              [class.example-expanded-row]="expandedPrice === price"
              (click)="expandedPrice = expandedPrice === price ? null : price" tabindex="0" (keydown.enter)="expandedPrice = expandedPrice === price ? null : price">
            </tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expandable-detail-row"></tr>
          </table>
          <!-- End of orders table-->
          <!-- Message while loading (show only if data.length is 0 and loading) -->
          @if (((this.repo.loading$ | async) ?? false) && data.length === 0) {
            <div class="padding center padding-top-bottom-50"
              >
              &nbsp;
            </div>
          }
          <!-- Paginator for the bottom -->
          <div class="spacer-small"></div>
          @if (data.length > 0) {
            <mat-paginator [pageSize]="this.repo.pageSize$ | async"
              [length]="this.repo.resourceCount$ | async" [pageIndex]="this.repo.pageNum$ | async"
              [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons="true"
            (page)="page($event)"></mat-paginator>
          }
          <!-- End of paginator for the bottom -->
        </div>
      }
      <!-- End of main pricing table-->
      <!-- Spinner (shows over entire card) -->
      @if (repo.loading$ | async) {
        <div class="loading-spinner-overlay">
          <mat-spinner></mat-spinner>
        </div>
      }
      <!-- End of spinner -->
      <lib-placeholder [iconName]="'cancel'" [iconClass]="'icon-error'" [message]="'common.messages.errorLoadingProductPricing' | transloco"
      [condition]="(this.repo.error$ | async) ?? false"></lib-placeholder>
    </div>
  }
</div>